import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './timeline-zoom-options.module.scss';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {TIMELINE_MAX_WIDTH_PER_SECOND, TIMELINE_MIN_WIDTH_PER_SECOND} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/poster-editor-web-bottom-bar.types';
import {updateTimelineWidthPerSecond} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/poster-editor-web-bottom-bar.reducer';

export function TimelineZoomOptions(): ReactElement {
  const widthPerSecond = useAppSelector((state) => {
    return state.posterEditorWebBottomBar.widthPerSecond;
  });
  const dispatch = useAppDispatch();

  const onSlide = (newVal: number): void => {
    dispatch(updateTimelineWidthPerSecond(newVal));
  };

  const getSliderForTimelineZoom = (): ReactElement => {
    return (
      <>
        <Icon icon="icon-zoom-out-timeline" className={`content-disabled ${styles.defaultMargin}`} size={IconSize.SIZE_ICON_16} />
        <ControlledSlider
          className={`${styles.defaultMargin} ${styles.slider}`}
          value={widthPerSecond}
          min={TIMELINE_MIN_WIDTH_PER_SECOND}
          max={TIMELINE_MAX_WIDTH_PER_SECOND}
          onSlide={onSlide}
        />
        <Icon icon="icon-zoom-in-timeline" className="content-disabled spacing-m-r-4" size={IconSize.SIZE_ICON_16} />
      </>
    );
  };

  const onMinimize = (): void => {
    window.posterEditor?.whiteboard?.updateIsTimelineMode(false);
  };

  return (
    <div className="flex-h-row flex-items-center">
      {getSliderForTimelineZoom()}
      <Icon onClick={onMinimize} icon="icon-collapse" size={IconSize.SIZE_ICON_20} shape={IconShape.SQUARE} type={IconType.GHOST} />
    </div>
  );
}
